import React from "react";
// External dependencies
import classNames from "classnames";

interface WrapperCardProps {
  className?: string; // Optional className for the card
  subClassName?: string; // Optional className for the sub-card
  children?: React.ReactNode; // To allow any React children
  isCollapsableAnalytics?: boolean; // Flag to determine if the card is collapsable
}



const WrapperCard: React.FC<WrapperCardProps> = ({
  className,
  subClassName,
  isCollapsableAnalytics = true, 
  ...props
}) => {
  // Combining default and additional classes for the card classess
  const CardClasses = classNames("col-lg-12 col-md-12 col-sm-12", className);
const boxShadowStyle = !isCollapsableAnalytics
  ? { boxShadow: "0px 30px 15px 1px rgba(69, 65, 78, 0.08)" }
  : {};
  // Combining default and additional classes for the sub-card lasses
  const CardSubClasses = classNames('m-portlet mb-0', subClassName);
  return (
    <div className={CardClasses}>
      <div className={CardSubClasses} style={boxShadowStyle}>{props.children}</div>
    </div>
  );
};

export default WrapperCard;
